import { render, staticRenderFns } from "./AlignButtons.vue?vue&type=template&id=09a45ce8&"
import script from "./AlignButtons.vue?vue&type=script&lang=js&"
export * from "./AlignButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports